import { DimeAlert, DimeAlertDescription, DimeAlertTitle, DimeButton } from '@nudool/design-system';
import { TriangleAlertIcon } from 'lucide-react';

type ListErrorStateProps = Readonly<{
  title: string;
  message: string;
  onRetry?: () => void;
  className?: string;
}>;

export function ListErrorState({ title, message, onRetry, className }: ListErrorStateProps) {
  return (
    <DimeAlert variant="destructive" className={className}>
      <TriangleAlertIcon />
      <DimeAlertTitle>{title}</DimeAlertTitle>
      <DimeAlertDescription className="flex flex-wrap items-center gap-x-2 gap-y-1">
        {message}
        {onRetry && (
          <DimeButton type="button" variant="link" className="h-auto px-0" onClick={onRetry}>
            Try again
          </DimeButton>
        )}
      </DimeAlertDescription>
    </DimeAlert>
  );
}
